import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string; // Optional title for the card
  className?: string; // Optional className for custom styling
}

const Card: React.FC<CardProps> = ({ children, title, className }) => {
  return (
    <div className={`${className} bg-bg-secondary p-4 rounded shadow border border-border-primary`}>
      {title && <h3 className="text-xl font-bold mb-4">{title}</h3>}
      {children}
    </div>
  );
};

export default Card;
